import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="single-click"
//
// Prevents a clickable element from being activated more than once. After the
// first click the element is visually and functionally disabled (pointer
// events off, aria-disabled true, reduced opacity). Use on POST links/cards
// that create records, where rapid double-clicks would create duplicates.
//
// The original click is allowed through so Turbo can still issue the request;
// only subsequent clicks are blocked.
//
// Usage:
//   <%= link_to neighbor_cases_path(neighbor),
//         method: :post,
//         data: { controller: 'single-click', action: 'click->single-click#disable' },
//         class: '... data-[disabled=true]:opacity-50 data-[disabled=true]:pointer-events-none' do %>
//     ...
//   <% end %>
export default class extends Controller<HTMLElement> {
  disable(event: Event) {
    if (this.element.dataset.disabled === "true") {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    this.element.dataset.disabled = "true";
    this.element.setAttribute("aria-disabled", "true");
    this.element.classList.add(
      "opacity-50",
      "pointer-events-none",
      "cursor-not-allowed",
    );
  }
}
